export default __webpack_public_path__ + "static/media/ne.7169a4f5.svg";